"use client"

import { createContext, useContext } from "react"
import { useCountry } from "@/components/layout/country-provider"
import { defaultBookingFlow, type BookingFlow } from "@/lib/membership-first"

/**
 * Whether the current page keeps the current booking flow on the
 * membership-first site. PageShell sets it from the path
 * (`keepsLegacyBooking`), so the ad pages under `/go` and `/lp` go on opening
 * booking.aheadhealth.com, the blood ones under `/go/bloodtest` aside, while
 * the rest of the market moves to the membership-first booking app.
 */
const LegacyBookingContext = createContext(false)

export function BookingFlowProvider({
  legacy,
  children,
}: {
  legacy: boolean
  children: React.ReactNode
}) {
  return (
    <LegacyBookingContext.Provider value={legacy}>
      {children}
    </LegacyBookingContext.Provider>
  )
}

/** The booking flow the CTAs on this page open. */
export function useBookingFlow(): BookingFlow {
  const { code: country } = useCountry()
  const legacy = useContext(LegacyBookingContext)
  return legacy ? "legacy" : defaultBookingFlow(country)
}
